///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.set_case = abcsetup.set_case || {};
abcsetup.set_case.workflow = abcsetup.set_case.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.set_case.workflow = {
    init: function() {

    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        // Bind any fields events
        abcsetup.set_case.common.bindFields();

        // Reject button clicked
        $('#reject-btn, .reject-btn.required').on('click', function () {
            return abcsetup.set_case.workflow.rejectCase($(this));
        });
    },

    /**
     * fieldError callback from _jquery.fieldValidate
     */
    fieldError: function() {
        abcsetup.set_case.common.fieldError();
    },

    /**
     * Reject the item
     */
    rejectCase: function (btn) {
        const rejectReasonField = $('textarea[name="reject_reason"].required');

        if (!rejectReasonField.val()) {
            rejectReasonField.addClass('error');
            return false;
        }

        btn.unbind('click').attr('type', 'submit').trigger('click');
    },
}